import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllUsers = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataUsers, setDataUsers] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllUsers, setLoadingFetchAllUsers ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/users`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllUsers(true)
        fetchData()
            .then((resp) => {
                setDataUsers(resp.rows)
                setLoadingFetchAllUsers(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllUsers(false)
            })
    }, [execute])

    return { dataUsers, loadingFetchAllUsers, executeFetch }

}

export const useFetchSpecificUser = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormUser } = Forms
    const { formState, setFormState } = FormUser
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificUser, setLoadingFetchSpecificUser ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idusuario: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/users/fetch-specific-user/${paramsToSearch.idusuario}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idusuario > 0 ){
            setLoadingFetchSpecificUser(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idusuario: rows[0].idusuario || '',
                        nombreusuario: rows[0].nombreusuario || '',
                        nombre: rows[0].nombre || '',
                        apellido: rows[0].apellido || '',
                        email: rows[0].email || '',
                        // userpassword: rows[0].userpassword || ''
                    }))
                    setLoadingFetchSpecificUser(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificUser(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificUser, setParamsToSearch, executeFetch }

}

export const useFetchPermissionsByUser = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    const [dataPermissions, setDataPermissions] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchPermissionsByUser, setLoadingFetchPermissionsByUser ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({
        idusuario: '',
        fetchAssignmentInfo: {
            flag: false,
            refSetFormState: null,
            formStateArrayName: ''
        }
    })

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataPermissions([])
        setParamsToSearch({
            idusuario: '',
            fetchAssignmentInfo: {
                flag: false,
                refSetFormState: null,
                formStateArrayName: ''
            }
        })
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/users/fetch-permissions-by-user/${paramsToSearch.idusuario}`)
            // console.log('[useFetchData][useFetchPermissionsByUser] response.data: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idusuario > 0 ){
            setLoadingFetchPermissionsByUser(true)
            fetchData()
                .then((resp) => {
                    
                    if(resp.rows.length === 0){
                        toast.warn('No se han encontrado permisos registrados en la base de datos', {
                            position: "top-right",
                            theme: "colored",
                            autoClose: false,
                        })
                        return
                    }
                    setDataPermissions(resp.rows)

                    if(paramsToSearch.fetchAssignmentInfo?.flag){

                        paramsToSearch.fetchAssignmentInfo.refSetFormState(prevState => ({
                            ...prevState,
                            idusuario: parseInt(resp.rows[0].idusuario, 10),
                            [ paramsToSearch.fetchAssignmentInfo.formStateArrayName ]: resp.rows
                        }))

                    }
                    setLoadingFetchPermissionsByUser(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchPermissionsByUser(false)
                })
        }
    }, [execute])

    return { loadingFetchPermissionsByUser, setParamsToSearch, executeFetch, resetFetch }

}